import {AbstractProfileCollection} from './abstractProfileCollection';
import {Availability} from '../model/availability';

export const UnAvailabilities = AbstractProfileCollection.extend({
    _name: 'UnAvailabilities',
    model: Availability,
    urlRoot: '/unavailabilities/get.json',
});
